"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceRuntime = void 0;
// Service runtime
let ServiceRuntime = exports.ServiceRuntime = /*#__PURE__*/function (ServiceRuntime) {
  // Localhost service runtime
  ServiceRuntime["Local"] = "Local";
  // Kubernetes service runtime
  ServiceRuntime["K8s"] = "K8s";
  // Intranet (inside virtual network)
  ServiceRuntime["VNet"] = "VNet";
  // Backend service
  ServiceRuntime["Backend"] = "Backend";
  // Publicly running service runtime
  ServiceRuntime["Public"] = "Public";
  return ServiceRuntime;
}({});
